"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initAction = exports.changeCopyDisabled = exports.INIT = exports.CHANGE_COPY_DISABLED = void 0;
var CHANGE_COPY_DISABLED = 'CHANGE_COPY_DISABLED';
/** для обновления переинициализации стейта */

exports.CHANGE_COPY_DISABLED = CHANGE_COPY_DISABLED;
var INIT = 'INIT';
exports.INIT = INIT;

var initAction = function initAction(state) {
  return {
    type: INIT,
    payload: state
  };
};

exports.initAction = initAction;

var changeCopyDisabled = function changeCopyDisabled(disabled) {
  return {
    type: CHANGE_COPY_DISABLED,
    payload: disabled
  };
};

exports.changeCopyDisabled = changeCopyDisabled;